// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".jy-common-dialog[data-v-391e2aec] (.el-dialog__body){max-height:72vh!important}", ""]);
// Exports
module.exports = exports;
